import { c as _c } from "react/compiler-runtime";
import { fallbackChainId, type ChainType } from "@/constants/chain-specific";
import { chainAggregators } from "@/constants/chain-specific/aggregators";
import { Chip } from "@heroui/react";
import type { DexConfig } from '@/constants/project-specific/farms/types';
import type { Address } from "viem";
import type { TokenConfigType } from "@/constants/types/currency";
import Image from "next/image";
import { findTokenByAddress } from "@/util/portfolio/tokenFilters";
interface DexRouteProps {
  address: Address;
  chainId: ChainType;
  pathIndex: number;
  tokenPath: readonly Address[] | null;
}
export default function DexRoute(t0) {
  const $ = _c(21);
  const {
    address,
    chainId,
    pathIndex,
    tokenPath
  } = t0;
  const adapter = chainAggregators[chainId ?? fallbackChainId]?.adapters?.[address] ?? null;
  const metadata = adapter?.metadata as DexConfig | "Wrapper" | "DEX" | "Vault";
  let t1;
  if ($[0] !== chainId || $[1] !== pathIndex || $[2] !== tokenPath) {
    t1 = tokenPath?.[pathIndex] ? findTokenByAddress(tokenPath[pathIndex] as Address, chainId) : null;
    $[0] = chainId;
    $[1] = pathIndex;
    $[2] = tokenPath;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const tokenIn = t1;
  let t2;
  if ($[4] !== chainId || $[5] !== pathIndex || $[6] !== tokenPath) {
    t2 = tokenPath?.[pathIndex + 1] ? findTokenByAddress(tokenPath[pathIndex + 1] as Address, chainId) : null;
    $[4] = chainId;
    $[5] = pathIndex;
    $[6] = tokenPath;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const tokenOut = t2;
  let t3;
  if ($[8] !== tokenIn) {
    t3 = tokenIn && <div className="w-6 h-6 rounded-full overflow-hidden"><img src={tokenIn.logo} alt={tokenIn.symbol} className="w-full h-full object-contain" /><span className="text-xs">{tokenIn.symbol}</span></div>;
    $[8] = tokenIn;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== metadata) {
    t4 = typeof metadata === "object" && metadata.logo ? <img src={metadata.logo} width={20} alt="logo" /> : null;
    $[10] = metadata;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = adapter?.name;
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <Chip startContent={t4} variant="shadow" color="primary" size="md">{t5}</Chip>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== tokenOut) {
    t7 = tokenOut && <div className="w-6 h-6 rounded-full overflow-hidden"><img src={tokenOut.logo} alt={tokenOut.symbol} className="w-full h-full object-contain" /><span className="text-xs">{tokenOut.symbol}</span></div>;
    $[15] = tokenOut;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t3 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex items-center gap-1">{t3}{t6}{t7}</div>;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}